import { __ } from "@wordpress/i18n";
import { Plus } from "lucide-react";
import { useRulesContext } from "../../../../hook/useRulesContext";

export default function Header() {
    const { setShowAddModal } = useRulesContext();
    return (
        <div className="px-4 sm:px-6 py-5 sm:py-5 border-b border-gray-200">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-xl sm:text-2xl font-bold text-gray-900 p-0">
                        {__(
                            "Quantity Rules",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </h1>
                    <p className="mt-1 text-xs sm:text-sm text-gray-500">
                        {__(
                            "Manage your quantity rules and their apply settings.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </p>
                </div>
                <button
                    onClick={() => setShowAddModal(true)}
                    className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm w-full sm:w-auto"
                >
                    <Plus className="w-4 h-4 mr-2" />

                    {__("Add New", "wpbean-quantity-controls-for-woocommerce")}
                </button>
            </div>
        </div>
    );
}
